import React from "react";
import { Link } from "react-router-dom";

import GoatFightHeader from "../components/home-page/HomePageHeader";
import GoatFightFooter from "../components/home-page/HomePageFooter";

import "../assets/css/goatfight-home.css";
import "../assets/css/golf-matchup.css";

// The simulation itself is a self-contained page in public/goat-fight.html.
// It is framed rather than ported so the model, the book and the scorecard
// stay in one reviewable file, and nothing in the React build can break it.
const GolfMatchup = () => (
  <main className="golf-matchup">
    <GoatFightHeader />

    <section className="golf-matchup__bar">
      <div className="golf-matchup__id">
        <p className="golf-matchup__eyebrow">Golf &middot; Cross-era simulation</p>
        <h1>Woods vs Nicklaus</h1>
      </div>
      <Link to="/golf" className="golf-matchup__back">Back to golf</Link>
    </section>

    <div className="golf-matchup__frame">
      <iframe
        src={`${process.env.PUBLIC_URL}/goat-fight.html`}
        title="Woods versus Nicklaus, simulated shot by shot"
      />
    </div>

    <GoatFightFooter />
  </main>
);

export default GolfMatchup;
